import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import CliIcon from "images/artwork.png";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  DialogContentText,
  FormHelperText
} from "@material-ui/core";
import { styles } from "./Preview.css";
import { _PermittedContent } from "../../_module/utils/PermittedContent";
import { Grid, Divider, Box, AppBar, Tabs, Tab, Chip, Button, Select, CircularProgress, MenuItem } from "@material-ui/core";
import clsx from "clsx";
// import { _mlPlaylists, _mlPlaylistsMetadataConfig } from "../../_module/definition/MlPlaylists";
import { _PermittedSetting } from "../../_module/utils/PermittedSetting";
import { TextInput } from "../input-elements/TextInput";
import ChipInput from "material-ui-chip-input";
import workspaceMusicOroigin from "../../_module/definition/workspaceMusicOroigin";
import { FaSave,FaTimes } from "react-icons/fa";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import ContentView from "./ContentView"
import UploadView from "./UploadView"
import {
  emptyItem,
  updateUploadTrack,
  trackEditItem,
  search as uploadSearch,
  addSessionItems,
  showAutoMessage,
  doReloadSession,
  uploadTrackSearchForPreview,
  setContributors,
  setErrors,
  contentTrackEditItem,
  setPrsTrackToEditTrack,
  showUploader
} from "../../redux/actions/MLTrackUpdateAction";
import {
  search
} from "../../redux/actions/SMLContentTrackAction";
import {
  search as albumTrackSearch
} from "../../redux/actions/MlUploadTracksAction";
import {
  search as mainSearch
} from "../../redux/actions/MlTrackLibraryActions";
import {
  search as uploadTrackSeach
} from "../../redux/actions/MLSessionUploadTrackAction";
import {
  search as mainAlbumTrackSearch,
} from "../../redux/actions/MlAlbumTrackActions";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import TrackEditContributers from "./track-edit/TrackEditContributers";
import { validateEditTrack } from "../../util/validations/content-validations/UploadValidation";
import PrsSearch from './prs-search/PrsSearch'
import MlPrsSearch from "util/prs-search/MlPrsSearch";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tab-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}


class TrackPreview extends Component {
  constructor() {
    super();
    this.state = {
      tabValue: 0,
      dirty: false,
      visibleData: true.valueOf,
      artWorkEdit: false,
      messageOpen: false,
      artworkMessageOpen: false,
      artwork: null,
      prevId: null,
      externalMessageOpen: false,
      isTrackEdited: false,
      isSecured: true,
      visiblePRS: false,
      prsAction: true,
      prsTrack: null,
      confirmMessageOpen: false,

    };
  }

  colsDef = null;
  colsDefAll = null;


  a11yProps = (index) => {
    const {
      updateData: { trackEditing },
      updateUploadTrack
    } = this.props;

    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  handleEditPicture = () => {
    const fileInput = document.getElementById("imageInput");
    fileInput.click();
  };

  handleSave = (e) => {   
    const {
      updateData: { trackEditing, contributorsEdit },
      updateUploadTrack,
      doReloadSession,
      setErrors
    } = this.props;
    if (trackEditing.trackMetadata) {
      trackEditing.trackMetadata.contributor = contributorsEdit;
    } 
    if (trackEditing.isAlbumEdit) {
      if (trackEditing) {
        let errors = validateEditTrack(trackEditing);
        if (errors) {
          setErrors(errors)
          return;
        }
      }
      this.setState({ messageOpen: true });
    }
    else {
      updateUploadTrack("Track Updating...", trackEditing, (data, err) => {
        this.setState({ messageOpen: false });

        //Commented due to Data null issue
        //if (data) {
        doReloadSession(true);
        this.setReload();
        //}
      });
    }
  }

  _isSandBox() {
    return this.props.location.pathname === "/mladmin/trackranking";
  }

  handleUpdateTrackOnly = () => {
    const {
      updateData: { trackEditing, contributorsEdit },
      updateUploadTrack,
      doReloadSession
    } = this.props;
    if (trackEditing) {
      let errors = validateEditTrack(trackEditing);
      if (errors) {
        setErrors(errors)
        return;
      }
    }
    if (trackEditing.trackMetadata) {
      trackEditing.trackMetadata.contributor = contributorsEdit;
    }
    trackEditing.isAlbumEdit = false
    updateUploadTrack("Track Updating...", trackEditing, (data) => {
      this.setState({ messageOpen: false });
      //Commented due to Data null issue
      //if (data) {
      doReloadSession(true);
      this.setReload();
      // }

    })
  };

  handleCloseMessage = () => {
    this.setState({ messageOpen: false });
    this.setState({ artworkMessageOpen: false });
  };



  handlePopupUpdate = () => {
    const {

      updateData: { trackEditing, contributorsEdit },
      updateUploadTrack,
      doReloadSession
    } = this.props;
    if (trackEditing.trackMetadata) {
      trackEditing.trackMetadata.contributor = contributorsEdit;
    }
    updateUploadTrack("Track Updating...", trackEditing, (data) => {
      this.setState({ messageOpen: false });
      //Commented due to Data null issue
      //if (data) {
      doReloadSession(true);
      this.setReload();
      //}
    })

  };

  setReload = () => {
    const {
      search,
      albumTrackSearch,
      libData: { query },
      uploadData: { query: uploadQuery },
      updateData: { trackEditing, query: updateQuery },
      match: { params, path },
      mainSearchData: { query: mainSearchQuery },
      uploadTrackSeach,
      mainSearch,
      mainAlbumTrackSearch,
      mainAlbumTrackData: { query: mainAlbumTrackSearchQuery },
      uploadTrackData: { query: uploadTrackDataQuery },
      uploadTrackSearchForPreview,
      contentTrackEditItem
    } = this.props;
    contentTrackEditItem(null);
    if (path.includes("/tracks/libraries") || path.includes("/tracks/workspaces")) {
      search({ ...query, page: 0 });
    }
    if (path.includes("/uploads/albums/")) {
      if (trackEditing.albumMetadata?.dh_album_id) {
        uploadQuery.filters = [];
        uploadQuery.filters = [...(query.filters?.filter((f) => f.field !== "dh_album_id") || []), { 'field': 'dh_album_id', 'operator': 'equals', 'value': [trackEditing.albumMetadata.dh_album_id] }]
      }
      if (params) {
        uploadQuery.filters = [];
        uploadQuery.filters = [...(query.filters?.filter((f) => f.field !== "dh_album_id") || []), { 'field': 'dh_album_id', 'operator': 'equals', 'value': [params.id] }]
      }
      albumTrackSearch({ ...uploadQuery, page: 0 });
    }
    if (path.includes("/search/tracks")) {
      mainSearch(mainSearchQuery, this._isSandBox());
    }
    if (path.includes("/uploads/tracks")) {
      uploadTrackSeach({ ...uploadTrackDataQuery })
    }
    if (path.includes("/search/album")) {
      mainAlbumTrackSearch({ ...query, albumId: params?.albumid, page: 0 })
    }
    if (path.includes("/uploads/session")) {
      uploadTrackSearchForPreview(updateQuery, null);
    }
  }

  handleValChange = (event, field = '') => {    

    const {
      trackEditItem,
      updateData: { trackEditing },
    } = this.props;

    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }

    if (field === "album_release_date") {
      trackEditing.albumMetadata['album_release_date'] = event;
      trackEditing.isAlbumEdit = true;
    }
    else if (field === "release_year") {
      trackEditing.albumMetadata['release_year'] = event;
      trackEditing.isAlbumEdit = true;
    }
    else if (field === "valid_from_date") {
      trackEditing.trackMetadata['valid_from_date'] = event;      
    }
    else if (field === "valid_to_date") {
      trackEditing.trackMetadata['valid_to_date'] = event;      
    }
    else {      
      const _name = event.target.name;
      const _val = event.target.value;

      if (_name == 'album_title'
        || _name == 'album_artist'
        || _name == 'catalogue_number'
        || _name == 'album_notes'
        || _name == 'upc' || _name == 'album_discs'
        || _name == 'album_admin_notes'
        || _name == "org_album_admin_notes"
        || _name == "cLine"
        || _name == "bbc_album_id"
        || _name == "prod_year"

      ) {
        trackEditing.isAlbumEdit = true;

        if (_name == 'album_discs') {
          trackEditing.albumMetadata[_name] = _val ? parseInt(_val) : 0;
        }
        else if (_name == 'prod_year') {
          trackEditing.albumMetadata[_name] = _val ? parseInt(_val) : 0;
        }
        else {
          trackEditing.albumMetadata[_name] = _val;
        }
      }
      else {
        if (_name == 'duration') {
          trackEditing.trackMetadata[_name] = _val ? parseFloat(_val) : null;
        }
        else {
          trackEditing.trackMetadata[_name] = _val;
        }
        this.state.isTrackEdited = true;
        this.setState({ dirty: true });
      }
    }
    trackEditItem(trackEditing);
  };

  handleVisible = () => {
    const {
      emptyItem,
    } = this.props;
    emptyItem();
    showUploader(true);
    this.state.isTrackEdited = false;

  }


  handleSearchPRS = () => {
    this.setState({ visiblePRS: true })

  }

  handleArtWorkEdit = () => {
    this.setState({ artWorkEdit: !this.state.artWorkEdit })
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  handlePerformersChange = (performers) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['performers'] = [...new Set(performers.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleArrangersChange = (arrangers) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['arrangers'] = [...new Set(arrangers.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }

  handlePublishersChange = (publishers) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['publishers'] = [...new Set(publishers.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleLyricistChange = (lyricist) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['lyricist'] = [...new Set(lyricist.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }

  handleComposerLyricistChange = (composer_lyricists) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['composer_lyricists'] = [...new Set(composer_lyricists.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  }
  handleComposersChange = (composers) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['composers'] = [...new Set(composers.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleTranslatorsChange = (translators) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['translators'] = [...new Set(translators.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleGenresChange = (genres) => {
    const {
      updateData: { trackEditing },
    } = this.props;

    trackEditing.trackMetadata['genres'] = [...new Set(genres.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleStylesChange = (styles) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['styles'] = [...new Set(styles.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleMoodsChange = (moods) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['moods'] = [...new Set(moods.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleInstrumentsChange = (instruments) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['instruments'] = [...new Set(instruments.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleKeywordsChange = (keywords) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['keywords'] = [...new Set(keywords.map(s => s.trim()))];
    this.state.isTrackEdited = true;

  }
  handleUserTagsChange = (userTags) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['org_userTags'] = [...new Set(userTags.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  }

  handleAdminTagsChange = (adminTags) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['org_adminTags'] = [...new Set(adminTags.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleAlbumUserTagsChange = (userTags) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.isAlbumEdit = true;
    trackEditing.albumMetadata['org_album_userTags'] = [...new Set(userTags.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleAlbumAdminTagsChange = (adminTags) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.isAlbumEdit = true;
    trackEditing.albumMetadata['org_album_adminTags'] = [...new Set(adminTags.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  //Conributors
  handleFeaturedArtist = (featured_artist) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['contributor_featured_artist'] = [...new Set(featured_artist.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleRemixArtist = (remix_artist) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['contributor_remix_artist'] = [...new Set(remix_artist.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleVersusArtist = (versus_artist) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['contributor_versus_artist'] = [...new Set(versus_artist.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleOrchestra = (orchestra) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['contributor_orchestra'] = [...new Set(orchestra.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleConductor = (conductor) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['contributor_conductor'] = [...new Set(conductor.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleChoir = (choir) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['contributor_choir'] = [...new Set(choir.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleEnsemble = (ensemble) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['contributor_ensemble'] = [...new Set(ensemble.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleAdaptor = (adaptor) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['adaptor'] = [...new Set(adaptor.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleAdministrator = (administrator) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['administrator'] = [...new Set(administrator.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleOriginalPublisher = (original_publisher) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['original_publisher'] = [...new Set(original_publisher.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleSubLyricist = (sub_lyricist) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['sub_lyricist'] = [...new Set(sub_lyricist.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleSubAdaptor = (sub_adaptor) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['sub_adaptor'] = [...new Set(sub_adaptor.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleSubArranger = (sub_arranger) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['sub_arranger'] = [...new Set(sub_arranger.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  handleSubPublisher = (sub_publisher) => {
    const {
      updateData: { trackEditing },
    } = this.props;
    trackEditing.trackMetadata['sub_publisher'] = [...new Set(sub_publisher.map(s => s.trim()))];
    this.state.isTrackEdited = true;
  };

  uploadArtwork = () => {
    const {
      updateData: { trackEditing },
    } = this.props;

    const { artwork } = this.state;
    trackEditing.trackMetadata.artwork_url = artwork;
    trackEditing.isAlbumEdit = true;
    this.setState({ artworkMessageOpen: false });
  };

  canCreateAdminNotes = () => {
    const {
      orgRuntime: {
        runtime: {
          _mlContentAdmin,
          _mlContentCanCreateAdminNotes,
        }
      }
    } = this.props;
    let canArchive = _PermittedContent(
      [_mlContentAdmin, _mlContentCanCreateAdminNotes],
      []
    )
      ? true
      : false;
    return canArchive;
  };

  canCreatePreRelease = () => {
    const {
      orgRuntime: {
        runtime: {
          _mlContentAdmin,
          _mlContentCanManagePreRelease,
        }
      }
    } = this.props;
    let canArchive = _PermittedContent(
      [_mlContentAdmin, _mlContentCanManagePreRelease],
      []
    )
      ? true
      : false;
    return canArchive;
  };

  onDrop = (event) => {
    const {
      updateData: { trackEditing },
      showAutoMessage
    } = this.props;
    if (event.target.files.length > 0) {
      var file = event.target.files[0];
      if (file.size > 1000000) {
        showAutoMessage("File size must be less than 1MB!")
      }
      else if (file.type != 'image/jpeg' && file.type != 'image/png') {
        showAutoMessage("File type must be JPEG or PNG")
      }
      else {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.setState({ artworkMessageOpen: true, artwork: reader.result })
        };
        reader.readAsDataURL(file);
      }

    }
  }




  // do not delete
  componentDidUpdate() {
    const {
      updateData: { editing,trackEditing},     
      setContributors
    } = this.props;

    if (editing && Object.keys(editing).length !== 0 && this.state.prevId !== editing?.dhTrack?.id) {
      this.setState({ prevId: editing?.dhTrack?.id }); 
      if (Object.keys(editing).length !== 0 && editing.wsType == "External") {
        this.setState({ externalMessageOpen: true })
      }
    }
  }

  componentDidMount() {
    const {
      updateData: { editing, trackEditing },
      setContributors
    } = this.props;    
    //Backend Album creation Error (ISRC Passing for album) Please Check
    setContributors(trackEditing.trackMetadata?.contributor)
  }


  getIpsText = (ipsArray) => {
    try {
      if (Array.isArray(ipsArray)) {
        return ipsArray
          ?.filter((r) => r?.fullName)
          .map((r) => r?.fullName)
          ?.join(", ");
      } else {
        return null;
      }
    } catch {
      return null;
    }
  };

  calcHeight() {
    if (!this.toolWrapper) return 248
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 50;
  }

  calcHeightEdit() {
    if (!this.toolWrapper) return 10
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 100;
  }

  calcHeight2() {
    if (!this.toolWrapper) return 248
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 22;
  }
  calcHeight3() {
    if (!this.toolWrapper) return 248
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 24;
  }
 
  calcHeightMeta2() {
    if (!this.toolWrapper) return 2
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 70;
  }
  calcHeightMeta() {
    if (!this.toolWrapper) return 2
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 97;
  }
  calcHeightinner() {
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;

    return rect.height - 127;

  }

  setSelectedTracks = () => {
    const {
      updateData: { trackEditing },
      trackEditItem
    } = this.props;

    trackEditing.trackMetadata.isrc = this.state.prsTrack?.isrc;
    trackEditing.trackMetadata.performers = this.state.prsTrack?.performer;
    trackEditing.trackMetadata.rec_label = this.state.prsTrack?.recordLabel;
    trackEditing.trackMetadata.prs_tune_code = this.state.prsTrack?.prs;    
    trackEditing["isPRS"] = true;
    trackEditItem(trackEditing);
    this.setState({ confirmMessageOpen: false })


    // if (prsTrack) {
    //   trackEditing.trackMetadata.prs_tune_code = prsTrack.prs;
    //   trackEditing["isPRS"] = false;
    //   trackEditItem(trackEditing);
    // }


  }

  updateTrackInformation = (prsTrack) => {
    this.setState({ confirmMessageOpen: true, prsTrack: prsTrack })
  }

  closeDialog = () => {
    const {
      updateData: { trackEditing },
      trackEditItem
    } = this.props;

    if (this.state.prsTrack) {
      trackEditing.trackMetadata.prs_tune_code = this.state.prsTrack?.prs;
      trackEditing["isPRS"] = false;
      trackEditItem(trackEditing);
    }

    this.setState({ confirmMessageOpen: false })

  }

  render() {


    const {
      classes,
      updateData: { selectedItem, selectionType, trackEditing, posting: { busy, message, errors } },
      uploadWindow,
      orgRuntime: {
        runtime: {
          musicOrigins: musicOrigins,
        }
      }
    } = this.props;

    const { messageOpen, artworkMessageOpen, externalMessageOpen, isTrackEdited, confirmMessageOpen } = this.state;

    return (

      <Translation>

        {(t, { i18n }) => (
          <Paper className={clsx(
            classes.sideBar,
            classes.uploadPreview
          )}
            role="contentinfo New" style={uploadWindow ? { height: `calc(100% - ${this.calcHeightinner()}px)` } : null}>
            {/* style={{ height: `calc(100% - ${this.calcHeight()}px)` }} */}

            {trackEditing ? (<>

              <Dialog
                open={confirmMessageOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={classes.dialogWrapper}
                class="dialogBox"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Confirmation Alert"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Would you like to update track information?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    className={classes.dialogYesButton}
                    onClick={(e) => {
                      this.setSelectedTracks();
                    }}
                    color="primary"
                    autoFocus
                  >
                    Yes
                  </Button>
                  <Button
                    className={classes.dialogNoButton}
                    onClick={() => this.closeDialog()}
                    color="primary"
                  >
                    No
                  </Button>
                </DialogActions>
              </Dialog>

              <div>

                <Dialog
                  open={messageOpen}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  className={classes.dialogWrapper}
                  class="dialogBox"
                >
                  <DialogTitle id="alert-dialog-title">{"Confirmation Alert"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      <Typography gutterBottom>
                        You are about to update the entire album. This change will effect all the tracks associate with the album.
                        {isTrackEdited && trackEditing.isAlbumEdit ? "Or You can edit only the track details." : null}
                      </Typography>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    {trackEditing.isAlbumEdit ? <Button color="primary" className={classes.dialogYesButton} autoFocus onClick={this.handlePopupUpdate} >
                      Update
                    </Button> : null}
                    {isTrackEdited && trackEditing.isAlbumEdit ? <Button className={classes.dialogYesButton} autoFocus onClick={this.handleUpdateTrackOnly} color="primary">
                      Update Track Only
                    </Button> : null}
                    <Button autoFocus className={classes.dialogNoButton} onClick={this.handleCloseMessage} color="primary">
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* ========== */}

                {/* ========== Upload Artwork */}
                <Dialog
                  open={artworkMessageOpen}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  className={classes.dialogWrapper}
                  class="dialogBox"
                >
                  <DialogTitle id="alert-dialog-title">{"Confirmation Alert"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      <Typography gutterBottom>
                        You are about to update the album artwok. This will effect all the tracks inside the album.
                      </Typography>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button color="primary" className={classes.dialogYesButton} autoFocus onClick={this.uploadArtwork} >
                      Update
                    </Button>
                    <Button autoFocus className={classes.dialogNoButton} onClick={this.handleCloseMessage} color="primary">
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* ========== */}



                <Translation>
                  {(t, { i18n }) => (
                    <Paper className={clsx(
                      // classes.sideBar,
                      classes.uploadPreview,
                      `${trackEditing ? classes.editView : ""}`
                    )} role="contentinfo">

                      {trackEditing && (trackEditing.wsType == "Owned" || trackEditing.wsType == "Master") ? (
                        <>
                          <Paper className={classes.disFlex}>
                            <h2 className={classes.muTitle}>
                              {trackEditing?.trackMetadata?.track_title}
                              <span className={classes.muSubTitle}>
                                {/* {trackEditing?.trackMetadata?.performers?.join()} */}
                                Edit Track
                              </span>
                            </h2>

                            <Button
                              title="Save changes"
                              className={clsx(
                                classes.commonTopButton,
                                classes.buttonCustomSize,
                                classes.globalGreenButton
                              )}

                              onClick={this.handleSave}
                            >
                              <FaSave
                                aria-label={"Save changes"}
                              />
                            </Button>
                            <Button
                              title="Cancel"
                              className={clsx(
                                classes.commonTopButton,
                                classes.buttonCustomSize,
                                classes.globalGrayButton
                              )}

                              onClick={this.handleVisible}
                            >
                              <CloseIcon
                                aria-label={"Cancel"}
                              />
                            </Button>
                          </Paper>
                          <div ref={(div) => (this.toolWrapper = div)}>
                            <Paper>

                              <Box p={1}>
                                <Grid
                                  container
                                  direction="column"
                                  alignItems="center"
                                  justify="center"
                                >
                                  <Grid
                                    container
                                    direction="column"
                                    alignItems="center"
                                    justify="center"
                                    style={{ height: 180, width: 180 }}
                                  >
                                    <div className={classes.trackEditContainer} >
                                      {trackEditing?.albumMetadata == null ? null :
                                        <Button
                                          onClick={this.handleEditPicture}
                                          aria-label={"Upload Artwork"}
                                          title={"Upload Artwork"}

                                        //disabled={trackEditing?.album_metadata == null}
                                        > <span className={classes.editIcon}>
                                            <EditIcon color="primary" />
                                          </span>
                                          <span className={classes.appbarHideLabel}>Hide Button</span>
                                        </Button>}

                                      <input
                                        type="file"
                                        id="imageInput"
                                        hidden="hidden"
                                        onChange={this.onDrop}
                                        aria-label="Image input"
                                        accept="image/jpeg, image/png"

                                      />
                                      {
                                        trackEditing && trackEditing.trackMetadata?.artwork_url ? (
                                          <img
                                            style={{ height: 180, width: 180 }}
                                            src={trackEditing.trackMetadata ? trackEditing.trackMetadata.artwork_url : ""}
                                            alt={trackEditing.trackMetadata.track_title}
                                          />
                                        ) : (
                                          <Grid
                                            container
                                            direction="column"
                                            alignItems="center"
                                            justify="center"
                                            className={classes.emptyArtwork}
                                            style={{ height: 160, width: 160 }}
                                          >
                                            <img className={"emptyArtwork"} style={{ width: 160 }} src={CliIcon}  alt="Sky Music - Placeholder" />
                                            {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                                          </Grid>
                                        )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Box>
                              <Divider />

                            </Paper>
                          </div>
                          <AppBar className={classes.trackTabsHeader} position="static">
                            <Tabs
                              value={this.state.tabValue}
                              onChange={this.handleTabChange}
                              scrollButtons="auto"
                              variant="scrollable"
                            >
                              <Tab label="Track Metadata" {...this.a11yProps(0)} />
                              <Tab label="Tags" {...this.a11yProps(1)} />
                              <Tab label="Album Metadata" {...this.a11yProps(2)} />
                            </Tabs>
                          </AppBar>
                          <TabPanel
                            className={classes.trackTabs}
                            value={this.state.tabValue}
                            index={0}
                          >

                            <Paper className={classes.sidebarDataContainer} style={uploadWindow ? { height: `calc(100% - ${this.calcHeight2()}px)` } : { height: `calc(100% - ${this.calcHeightMeta()}px)` }}>
                              <div   className={clsx(classes.sidebarWrappedData, `${trackEditing ? classes.editView : ""}`,"editViewLg")}>
                                {/* style={{ height: `calc(100% - ${this.calcHeightinner()}px)` }} */}
                                <Grid item xs={12} >

                                  {/* <div className={classes.uploadSaveButton}>
                                  </div> */}
                                  {/* <div className={classes.nonEditable}>
                                    <TextElement
                                      label="ID"
                                      classes={classes}
                                      data={trackEditing.trackMetadata?.id}
                                    />
                                  </div> */}

                                  <div className={clsx(classes.muDetailWrap, classes.nonEditable)}>
                                    <div className={classes.muLabels} >ID</div>
                                    <div className={classes.muDetails} >
                                      {trackEditing.trackMetadata?.id}
                                    </div>
                                  </div>

                                  <div className={classes.globalInput}>

                                    {/* <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        BBC Track Barcode
                                      </label>
                                      <TextInput
                                        name="bbc_track_id"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "BBC Track Barcode"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.bbc_track_id : "" || ""}
                                        errors={errors || {}}
                                      />
                                      {errors && errors.bbc_track_id && (<span role="alert" className={classes.appbarHideLabel} >{errors.bbc_track_id}</span>)}

                                    </div> */}
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}
                                      >
                                        Track Title <span aria-label="Track Title required" className={classes.reqSymbol}>*</span>{" "}
                                      </label>
                                      <TextInput
                                        name="track_title"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "Track title"
                                        }}
                                        inputRef={(input) => {
                                          if (input) {
                                            input.focus();
                                          }
                                        }}
                                        handleChange={(e) => this.handleValChange(e)}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.track_title : "" || ""}
                                        errors={errors || {}}
                                        autoFocus
                                      />
                                      {errors && errors.track_title && (<span role="alert" className={classes.appbarHideLabel} >{errors.track_title}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}
                                      >
                                        ALTERNATE TITLE
                                      </label>
                                      <TextInput
                                        name="alternate_title"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "ALTERNATE TITLE"
                                        }}
                                        inputRef={(input) => {
                                          if (input) {
                                            input.focus();
                                          }
                                        }}
                                        handleChange={(e) => this.handleValChange(e)}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.alternate_title : "" || ""}
                                        errors={errors || {}}
                                        autoFocus
                                      />
                                      {errors && errors.alternate_title && (<span role="alert" className={classes.appbarHideLabel} >{errors.alternate_title}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}
                                      >
                                        VERSION TITLE
                                      </label>
                                      <TextInput
                                        name="version_title"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "VERSION TITLE"
                                        }}
                                        inputRef={(input) => {
                                          if (input) {
                                            input.focus();
                                          }
                                        }}
                                        handleChange={(e) => this.handleValChange(e)}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.version_title : "" || ""}
                                        errors={errors || {}}
                                        autoFocus
                                      />
                                      {errors && errors.version_title && (<span role="alert" className={classes.appbarHideLabel} >{errors.version_title}</span>)}

                                    </div>
                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Artist
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.performers : [] || []}
                                        onChange={(performers) => this.handlePerformersChange(performers)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Artists"
                                          },
                                        }}

                                      />
                                      {errors && errors.performers && (<span role="alert" className={classes.Muierror}>{errors.performers}</span>)}

                                    </div>

                                    {/* <div>
                                      <label
                                        className={classes.globalCreateLabel}
                                      >
                                        PRODUCTION LIBRARY
                                      </label>
                                      <TextInput
                                        name="production_library"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "PRODUCTION LIBRARY"
                                        }}
                                        inputRef={(input) => {
                                          if (input) {
                                            input.focus();
                                          }
                                        }}
                                        handleChange={(e) => this.handleValChange(e)}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.production_library : "" || ""}
                                        errors={errors || {}}
                                        autoFocus
                                      />
                                      {errors && errors.production_library && (<span role="alert" className={classes.appbarHideLabel} >{errors.production_library}</span>)}

                                    </div> */}
                                    <div className={clsx(classes.tableFilterInput, classes.musicOrigin)}>
                                      <div>
                                        <label
                                          className={classes.globalCreateLabel}>
                                          Origin
                                        </label>
                                        <Select
                                          variant="outlined"
                                          name="musicorigin"
                                          inputProps={{
                                            'id': "Music origin",
                                            'aria-labelledby': "Music origin"
                                          }}
                                          value={trackEditing.trackMetadata ? trackEditing.trackMetadata.musicorigin : "" || ""}
                                          onChange={this.handleValChange}
                                        >
                                          {Object.keys(musicOrigins).map((v, i) => (
                                            <MenuItem value={musicOrigins[v].id}>
                                              {musicOrigins[v].name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </div>
                                    </div>
                                    <div className={clsx(classes.tableFilterInput, classes.musicOrigin)}>
                                      <div>
                                        <label
                                          className={classes.globalCreateLabel}>
                                          Sub Origin
                                        </label>
                                        <Select
                                          variant="outlined"
                                          name="sub_origin"
                                          inputProps={{
                                            'id': "Sub origin",
                                            'aria-labelledby': "Sub origin"
                                          }}
                                          value={trackEditing.trackMetadata ? trackEditing.trackMetadata.sub_origin : "" || ""}
                                          onChange={this.handleValChange}
                                          defaultValue={1}
                                        >
                                          {Object.keys(workspaceMusicOroigin).map((v, i) => (
                                            <MenuItem value={workspaceMusicOroigin[v].id}>
                                              {workspaceMusicOroigin[v].name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </div>
                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Position
                                      </label>
                                      <TextInput
                                        name="position"
                                        type="number"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "Position",
                                          "min": "0",
                                          "max": "1000"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.position : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.position && (<span role="alert" className={classes.appbarHideLabel} >{errors.position}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Disc Number
                                      </label>
                                      <TextInput
                                        name="disc_number"
                                        type="number"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "Disc Number",
                                          "min": "0"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.disc_number : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.disc_number && (<span role="alert" className={classes.appbarHideLabel} >{errors.disc_number}</span>)}

                                    </div>
                                    {/* <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Duration (Seconds)
                                      </label>
                                      <TextInput
                                        name="duration"
                                        type="number"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "Duration (Seconds)",
                                          "min": "0",

                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.duration : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.duration && (<span role="alert" className={classes.appbarHideLabel} >{errors.duration}</span>)}

                                    </div> */}
                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Publisher
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.publishers : [] || []}
                                        onChange={(publishers) => this.handlePublishersChange(publishers)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Publishers"
                                          },
                                        }}
                                      />
                                      {errors && errors.publishers && (<span role="alert" className={classes.Muierror} >{errors.publishers}</span>)}

                                    </div>
                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Composer
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.composers : [] || []}
                                        onChange={(composers) => this.handleComposersChange(composers)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Composers"
                                          },
                                        }}
                                      />
                                      {errors && errors.composers && (<span role="alert" className={classes.Muierror} >{errors.composers}</span>)}

                                    </div>

                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Arranger
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.arrangers : [] || []}
                                        onChange={(arrangers) => this.handleArrangersChange(arrangers)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Arrangers"
                                          },
                                        }}
                                      />
                                      {errors && errors.arrangers && (<span role="alert" className={classes.Muierror} >{errors.arrangers}</span>)}

                                    </div>
                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Sub Arranger
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.sub_arranger : [] || []}
                                        onChange={(sub_arranger) => this.handleSubArranger(sub_arranger)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Sub Arranger"
                                          },
                                        }}
                                      />
                                      {errors && errors.sub_arranger && (<span role="alert" className={classes.Muierror} >{errors.sub_arranger}</span>)}

                                    </div>
                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Lyricist
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.lyricist : [] || []}
                                        onChange={(lyricist) => this.handleLyricistChange(lyricist)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Lyricists"
                                          },
                                        }}
                                      />
                                      {errors && errors.lyricist && (<span role="alert" className={classes.Muierror} >{errors.lyricist}</span>)}

                                    </div>
                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Sub Lyricist
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.sub_lyricist : [] || []}
                                        onChange={(sub_lyricist) => this.handleSubLyricist(sub_lyricist)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Sub Lyricist"
                                          },
                                        }}
                                      />
                                      {errors && errors.sub_lyricist && (<span role="alert" className={classes.Muierror} >{errors.sub_lyricist}</span>)}

                                    </div>
                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Composer Lyricist
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.composer_lyricists : [] || []}
                                        onChange={(composer_lyricists) => this.handleComposerLyricistChange(composer_lyricists)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Composer Lyricist"
                                          },
                                        }}
                                      />
                                      {errors && errors.composer_lyricists && (<span role="alert" className={classes.Muierror} >{errors.composer_lyricists}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Adaptor
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.adaptor : [] || []}
                                        onChange={(adaptor) => this.handleAdaptor(adaptor)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Adaptor"
                                          },
                                        }}
                                      />
                                      {errors && errors.adaptor && (<span role="alert" className={classes.Muierror} >{errors.adaptor}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Sub Adaptor
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.sub_adaptor : [] || []}
                                        onChange={(sub_adaptor) => this.handleSubAdaptor(sub_adaptor)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Sub Adaptor"
                                          },
                                        }}
                                      />
                                      {errors && errors.sub_adaptor && (<span role="alert" className={classes.Muierror} >{errors.sub_adaptor}</span>)}
                                    </div>

                                    <div className={classes.globaltrackEdit}>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Translator
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.translators : [] || []}
                                        onChange={(translators) => this.handleTranslatorsChange(translators)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "Translators"
                                          },
                                        }}
                                      />
                                      {errors && errors.translators && (<span role="alert" className={classes.Muierror} >{errors.translators}</span>)}

                                    </div>


                                    <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Original Publisher
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.original_publisher : [] || []}
                                      onChange={(original_publisher) => this.handleOriginalPublisher(original_publisher)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Original Publisher"
                                        },
                                      }}
                                    />
                                    {errors && errors.original_publisher && (<span role="alert" className={classes.Muierror} >{errors.original_publisher}</span>)}

                                  </div>


                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Sub Publisher
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.sub_publisher : [] || []}
                                      onChange={(sub_publisher) => this.handleSubPublisher(sub_publisher)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Sub Publisher"
                                        },
                                      }}
                                    />
                                    {errors && errors.sub_publisher && (<span role="alert" className={classes.Muierror} >{errors.sub_publisher}</span>)}
                                  </div> 
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Track Note
                                      </label>
                                      <TextInput
                                        name="track_notes"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "Track notes"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.track_notes : "" || ""}
                                        errors={errors || {}}
                                      />
                                      {errors && errors.track_notes && (<span role="alert" className={classes.appbarHideLabel} >{errors.track_notes}</span>)}

                                    </div>

                                    {this.canCreateAdminNotes() && (
                                      <div>
                                        <label
                                          className={classes.globalCreateLabel}>
                                          Admin Notes
                                        </label>
                                        <TextInput
                                          name="org_admin_notes"
                                          type="text"
                                          classes={classes}
                                          inputProps={{
                                            'aria-label': "Admin Notes"
                                          }}
                                          handleChange={this.handleValChange}
                                          value={trackEditing.trackMetadata ? trackEditing.trackMetadata.org_admin_notes : "" || ""}
                                          errors={errors || {}}
                                        />
                                        {errors && errors.org_admin_notes && (<span role="alert" className={classes.appbarHideLabel} >{errors.org_admin_notes}</span>)}

                                      </div>
                                    )}                                   
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        BPM
                                      </label>
                                      <TextInput
                                        name="bpm"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "BPM"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.bpm : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.bpm && (<span role="alert" className={classes.appbarHideLabel} >{errors.bpm}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        TEMPO
                                      </label>
                                      <TextInput
                                        name="tempo"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "Tempo"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.tempo : "" || ""}
                                        errors={errors || {}}
                                      />
                                      {errors && errors.tempo && (<span role="alert" className={classes.appbarHideLabel} >{errors.tempo}</span>)}

                                    </div>

                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        ISRC
                                      </label>
                                      <TextInput
                                        name="isrc"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "ISRC"
                                        }}
                                        handleChange={(e) => this.handleValChange(e)}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.isrc : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.isrc && (<span role="alert" className={classes.appbarHideLabel} >{errors.isrc}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        ISWC
                                      </label>
                                      <TextInput
                                        name="iswc"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "ISWC"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.iswc : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.iswc && (<span role="alert" className={classes.appbarHideLabel} >{errors.iswc}</span>)}

                                    </div>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        MCPS ID
                                      </label>
                                      <TextInput
                                        name="org_sky_MCPSID"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "MCPS ID"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.org_sky_MCPSID : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.org_sky_MCPSID && (<span role="alert" className={classes.appbarHideLabel} >{errors.org_sky_MCPSID}</span>)}

                                    </div>
                                    {/* <div>
                                      <label
                                        className={classes.globalCreateLabel}
                                      >
                                        PRS TUNE CODE
                                      </label>
                                      <TextInput
                                        name="prs_tune_code"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "PRS TUNE CODE"
                                        }}
                                        inputRef={(input) => {
                                          if (input) {
                                            input.focus();
                                          }
                                        }}
                                        handleChange={(e) => this.handleValChange(e)}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.prs_tune_code : "" || ""}
                                        errors={errors || {}}
                                        autoFocus
                                      />
                                      {errors && errors.prs_tune_code && (<span role="alert" className={classes.appbarHideLabel} >{errors.prs_tune_code}</span>)}

                                    </div> */}
                                    {/* <div className={classes.nonEditable}>
                                      <TextElement
                                        label="PRS TUNE CODE"
                                        classes={classes}
                                        data={trackEditing.trackMetadata?.prs_tune_code}
                                      />
                                    </div> */}
                                  </div>

                                  <div className={clsx(classes.muDetailWrap, classes.nonEditable)}>
                                    <div className={classes.muLabels} >Datahub PRS</div>
                                    <div className={classes.muDetails} >
                                      {trackEditing.trackMetadata?.prs}
                                    </div>

                                  </div>

                                  <div className={clsx(classes.muDetailWrap, classes.nonEditable)}>
                                    <div title="PRS TUNE CODE" className={classes.muLabels}
                                      style={trackEditing.trackMetadata?.prs_tune_code ? null : { width: '100%' }}>PRS TUNE CODE</div>
                                    <div className={classes.muDetails} >
                                      {trackEditing.trackMetadata?.prs_tune_code}
                                    </div>
                                    <div>
                                      {/* <PrsSearch /> */}
                                      <MlPrsSearch
                                        alwaysActive={true}
                                        withBackBtn={false}
                                        buttonLabel="Search PRS"
                                        actionLabel="Select Track"
                                        sourceTitle={trackEditing.trackMetadata ? trackEditing.trackMetadata.track_title : "" || ""}
                                        sourcePerformer={trackEditing.trackMetadata ? trackEditing.trackMetadata.performers : [] || []}
                                        importData={(selectedPrsTrack) => { this.updateTrackInformation(selectedPrsTrack) }}
                                      />
                                    </div>
                                  </div>

                                  {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      PARENTAL WARNING
                                    </label>
                                    <TextInput
                                      name="parental_warning"
                                      type="text"
                                      classes={classes}
                                      disabled={true}
                                      inputProps={{
                                        'aria-label': "PARENTAL WARNING"
                                      }}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.trackMetadata ? trackEditing.trackMetadata.parental_warning : "" || ""}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.parental_warning && (<span role="alert" className={classes.appbarHideLabel} >{errors.parental_warning}</span>)}

                                  </div> */}
                                  {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Adaptor
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.adaptor : [] || []}
                                      onChange={(adaptor) => this.handleAdaptor(adaptor)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Adaptor"
                                        },
                                      }}
                                    />
                                    {errors && errors.adaptor && (<span role="alert" className={classes.Muierror} >{errors.adaptor}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Administrator
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.administrator : [] || []}
                                      onChange={(administrator) => this.handleAdministrator(administrator)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Administrator"
                                        },
                                      }}
                                    />
                                    {errors && errors.administrator && (<span role="alert" className={classes.Muierror} >{errors.administrator}</span>)}

                                  </div>

                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Sub Lyricist
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.sub_lyricist : [] || []}
                                      onChange={(sub_lyricist) => this.handleSubLyricist(sub_lyricist)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Sub Lyricist"
                                        },
                                      }}
                                    />
                                    {errors && errors.sub_lyricist && (<span role="alert" className={classes.Muierror} >{errors.sub_lyricist}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Sub Adaptor
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.sub_adaptor : [] || []}
                                      onChange={(sub_adaptor) => this.handleSubAdaptor(sub_adaptor)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Sub Adaptor"
                                        },
                                      }}
                                    />
                                    {errors && errors.sub_adaptor && (<span role="alert" className={classes.Muierror} >{errors.sub_adaptor}</span>)}
                                  </div>
                                */}

                                  {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      External Prs Publishers
                                    </label>
                                    <TextInput
                                      name="prs_work_publishers"
                                      type="text"
                                      classes={classes}
                                      disabled={true}
                                      inputProps={{
                                        'aria-label': "External Prs Publishers"
                                      }}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.trackMetadata ? trackEditing.trackMetadata.prs_work_publishers : "" || ""}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.prs_work_publishers && (<span role="alert" className={classes.appbarHideLabel} >{errors.prs_work_publishers}</span>)}

                                  </div> */}

                                  <div className={clsx(classes.muDetailWrap, classes.nonEditable)}>
                                    <div title="EXTERNAL PRS PUBLISHERS" className={classes.muLabels}
                                      style={trackEditing.trackMetadata?.prs_tune_code ? null : { width: '100%' }}>External Prs Publishers</div>
                                    <div className={classes.muDetails} >
                                      {trackEditing.trackMetadata?.prs_work_publishers}
                                    </div>
                                  </div>
                                  {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      External Prs Work Title
                                    </label>
                                    <TextInput
                                      name="prs_work_title"
                                      type="text"
                                      classes={classes}
                                      disabled={true}
                                      inputProps={{
                                        'aria-label': "External Prs Work Title"
                                      }}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.trackMetadata ? trackEditing.trackMetadata.prs_work_title : "" || ""}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.prs_work_title && (<span role="alert" className={classes.appbarHideLabel} >{errors.prs_work_title}</span>)}

                                  </div> */}
                                  {/* <div className={classes.nonEditable}>
                                    <TextElement
                                      label="External Prs Work Title"
                                      classes={classes}
                                      data={trackEditing.trackMetadata?.prs_work_title}
                                    />
                                  </div> */}
                                  <div className={clsx(classes.muDetailWrap, classes.nonEditable)}>
                                    <div title="EXTERNAL PRS WORK TITLE" className={classes.muLabels}
                                      style={trackEditing.trackMetadata?.prs_tune_code ? null : { width: '100%' }}>External Prs Work Title</div>
                                    <div className={classes.muDetails} >
                                      {trackEditing.trackMetadata?.prs_work_title}
                                    </div>
                                  </div>
                                  {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      External Prs Tune Code
                                    </label>
                                    <TextInput
                                      name="prs_work_tunecode"
                                      type="text"
                                      classes={classes}
                                      disabled={true}
                                      inputProps={{
                                        'aria-label': "External Prs Tune Code"
                                      }}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.trackMetadata ? trackEditing.trackMetadata.prs_work_tunecode : "" || ""}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.prs_work_tunecode && (<span role="alert" className={classes.appbarHideLabel} >{errors.prs_work_tunecode}</span>)}

                                  </div> */}
                                  {/* <div className={classes.nonEditable}>
                                    <TextElement
                                      label="External Prs Tune Code"
                                      classes={classes}
                                      data={trackEditing.trackMetadata?.prs_work_tunecode}
                                    />
                                  </div> */}
                                  <div className={clsx(classes.muDetailWrap, classes.nonEditable)}>
                                    <div title="EXTERNAL PRS TUNE CODE" className={classes.muLabels}
                                      style={trackEditing.trackMetadata?.prs_tune_code ? null : { width: '100%' }}>External Prs Tune Code</div>
                                    <div className={classes.muDetails} >
                                      {trackEditing.trackMetadata?.prs_work_tunecode}
                                    </div>
                                  </div>
                                  {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      External Prs Writers
                                    </label>
                                    <TextInput
                                      name="prs_work_writers"
                                      type="text"
                                      classes={classes}
                                      disabled={true}
                                      inputProps={{
                                        'aria-label': "External Prs Writers"
                                      }}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.trackMetadata ? trackEditing.trackMetadata.prs_work_writers : "" || ""}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.prs_work_writers && (<span role="alert" className={classes.appbarHideLabel} >{errors.prs_work_writers}</span>)}

                                  </div> */}
                                  {/* <div className={classes.nonEditable}>
                                    <TextElement
                                      label="External Prs Writers"
                                      classes={classes}
                                      data={trackEditing.trackMetadata?.prs_work_writers}
                                    />
                                  </div> */}
                                  <div className={clsx(classes.muDetailWrap, classes.nonEditable)}>
                                    <div title="EXTERNAL PRS WRITERS" className={classes.muLabels}
                                      style={trackEditing.trackMetadata?.prs_tune_code ? null : { width: '100%' }} >External Prs Writers</div>
                                    <div className={classes.muDetails} >
                                      {trackEditing.trackMetadata?.prs_work_writers}
                                    </div>
                                  </div>
                                  <div className={classes.globalInput}>
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Playout Contributors
                                      </label>
                                      <TrackEditContributers {...this.props} />
                                    </div>
                                    {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Datahub PRS
                                    </label>
                                    <TextInput
                                      name="prs"
                                      type="text"
                                      classes={classes}
                                      inputProps={{
                                        'aria-label': "Datahub PRS"
                                      }}
                                      disabled={true}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.trackMetadata ? trackEditing.trackMetadata.prs : "" || ""}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.prs && (<span role="alert" className={classes.appbarHideLabel} >{errors.prs}</span>)}

                                  </div> */}
                                    {/* <div className={classes.nonEditable}>
                                    <TextElement
                                      label="Datahub PRS"
                                      classes={classes}
                                      data={trackEditing.trackMetadata?.prs}
                                    />
                                  </div> */}

                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        P Line
                                      </label>
                                      <TextInput
                                        name="pLine"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "P line"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.trackMetadata ? trackEditing.trackMetadata.pLine : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.pLine && (<span role="alert" className={classes.appbarHideLabel} >{errors.pLine}</span>)}

                                    </div>

                                    {this.canCreatePreRelease() && (   
                                    <div className={clsx(classes.calendarOverride, classes.calendarFieldOverride)}>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="valid_from_date"
                                    >
                                      Valid From {" "}
                                    </label>

                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <DatePicker
                                        name="valid_from_date"
                                        aria-label='Valid From Date'
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        className={clsx(classes.tableFilterInput, classes.tableFilterDate,classes.datevalidInput)}
                                        value={trackEditing.trackMetadata?.valid_from_date ? moment(trackEditing.trackMetadata.valid_from_date, 'yyyy-MM-DD').toDate() : null}
                                        onChange={event => {
                                          this.handleValChange(
                                            event ? moment(event).format('yyyy-MM-DD') : "",
                                            'valid_from_date');
                                        }}
                                        autoOk
                                        inputProps={{
                                          'aria-label': 'Valid From Date'
                                        }}
                                        helperText={errors && errors["valid_from_date"] || ""}
                                        error={errors && errors["valid_from_date"] ? true : false}
                                      />
                                      {trackEditing.trackMetadata.valid_from_date &&
                                      <Button   
                                        onClick={() => this.handleValChange('', 'valid_from_date')}                                                 
                                        aria-label="Clear date"
                                        className={classes.clearButton}
                                        >
                                      {<FaTimes />}
                                    </Button> }    
                                    </MuiPickersUtilsProvider>
                                  </div>)}
                                  {this.canCreatePreRelease() && (   
                                  <div className={clsx(classes.calendarOverride, classes.calendarFieldOverride)}>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="valid_to_date"
                                    >
                                      Valid To {" "}
                                    </label>

                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <DatePicker
                                        name="valid_to_date"
                                        aria-label='Valid To Date'
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        className={clsx(classes.tableFilterInput, classes.tableFilterDate, classes.datevalidInput)}
                                        value={trackEditing.trackMetadata?.valid_to_date ? moment(trackEditing.trackMetadata.valid_to_date, 'yyyy-MM-DD').toDate() : null}
                                        onChange={event => {
                                          this.handleValChange(
                                            event ? moment(event).format('yyyy-MM-DD') : "",
                                            'valid_to_date');
                                        }}
                                        autoOk
                                        inputProps={{
                                          'aria-label': 'Valid To Date'
                                        }}
                                        helperText={errors && errors["valid_to_date"] || ""}
                                        error={errors && errors["valid_to_date"] ? true : false}
                                      /> 
                                      {trackEditing.trackMetadata.valid_to_date &&
                                      <Button   
                                        onClick={() => this.handleValChange('', 'valid_to_date')}                                                 
                                        aria-label="Clear date"
                                        className={classes.clearButton}
                                        >
                                      {<FaTimes />}
                                    </Button> }                                   
                                    </MuiPickersUtilsProvider>
                                  </div>)}

                                    {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Contributor Featured Artist
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.contributor_featured_artist : [] || []}
                                      onChange={(bbc_track_contributor_featured_artist) => this.handleFeaturedArtist(bbc_track_contributor_featured_artist)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Contributor Featured Artist"
                                        },
                                      }}
                                    />
                                    {errors && errors.contributor_featured_artist && (<span role="alert" className={classes.Muierror} >{errors.contributor_featured_artist}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Contributor Remix Artist
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.contributor_remix_artist : [] || []}
                                      onChange={(bbc_track_contributor_remix_artist) => this.handleRemixArtist(bbc_track_contributor_remix_artist)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Contributor Remix Artist"
                                        },
                                      }}
                                    />
                                    {errors && errors.contributor_remix_artist && (<span role="alert" className={classes.Muierror} >{errors.contributor_remix_artist}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Contributor Versus Artist
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.contributor_versus_artist : [] || []}
                                      onChange={(bbc_track_contributor_versus_artist) => this.handleVersusArtist(bbc_track_contributor_versus_artist)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Contributor Versus Artist"
                                        },
                                      }}
                                    />
                                    {errors && errors.contributor_versus_artist && (<span role="alert" className={classes.Muierror} >{errors.contributor_versus_artist}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Contributor Orchestra
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.contributor_orchestra : [] || []}
                                      onChange={(bbc_track_contributor_orchestra) => this.handleOrchestra(bbc_track_contributor_orchestra)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Contributor Orchestra"
                                        },
                                      }}
                                    />
                                    {errors && errors.contributor_orchestra && (<span role="alert" className={classes.Muierror} >{errors.contributor_orchestra}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Contributor Conductor
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.contributor_conductor : [] || []}
                                      onChange={(bbc_track_contributor_conductor) => this.handleConductor(bbc_track_contributor_conductor)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Contributor Conductor"
                                        },
                                      }}
                                    />
                                    {errors && errors.contributor_conductor && (<span role="alert" className={classes.Muierror} >{errors.contributor_conductor}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Contributor Choir
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.contributor_choir : [] || []}
                                      onChange={(bbc_track_contributor_choir) => this.handleChoir(bbc_track_contributor_choir)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Contributor Choir"
                                        },
                                      }}
                                    />
                                    {errors && errors.contributor_choir && (<span role="alert" className={classes.Muierror} >{errors.contributor_choir}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Contributor Ensemble
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.contributor_ensemble : [] || []}
                                      onChange={(bbc_track_contributor_ensemble) => this.handleEnsemble(bbc_track_contributor_ensemble)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "Contributor Ensemble"
                                        },
                                      }}
                                    />
                                    {errors && errors.contributor_ensemble && (<span role="alert" className={classes.Muierror} >{errors.contributor_ensemble}</span>)}

                                  </div> */}




                                  </div>
                                </Grid>
                                <div className={classes.uploadSaveButton}>

                                  <div>
                                    <Button
                                      className={classes.globalGrayButton}
                                      onClick={this.handleVisible}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      className={classes.globalGreenButton}
                                      disabled={busy ? true : false}
                                      onClick={this.handleSave}
                                    >
                                      Save
                                      {busy && (
                                        <CircularProgress size={20} className={classes.progress} />
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </Paper>
                          </TabPanel>

                          <TabPanel
                            className={classes.trackTabs}
                            value={this.state.tabValue}
                            index={1}
                          >
                            <Paper className={classes.sidebarDataContainer} style={uploadWindow ? { height: `calc(100% - ${this.calcHeight3()}px)` } : { height: `calc(100% - ${this.calcHeightMeta2()}px)` }}>
                              <div style={uploadWindow ? null : { height: `calc(100% - ${this.calcHeightinner()}px)` }} className={clsx(classes.sidebarWrappedData, `${trackEditing ? classes.editView : ""}`,"test2")}>
                                <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                  <label
                                    className={classes.globalCreateLabel}
                                    htmlFor="moods"
                                  >
                                    MOOD
                                  </label>
                                  <ChipInput
                                    variant="outlined"
                                    defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.moods : [] || []}
                                    onChange={(moods) => this.handleMoodsChange(moods)}
                                    allowDuplicates={false}
                                    InputProps={{
                                      inputProps: {
                                        "aria-label": "MOODS"
                                      },
                                    }}
                                  />
                                  {errors && errors.moods && (<span role="alert" className={classes.Muierror} >{errors.moods}</span>)}

                                </div>
                                <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                  <label
                                    className={classes.globalCreateLabel}
                                    htmlFor="styles"
                                  >
                                    STYLE
                                  </label>
                                  <ChipInput
                                    variant="outlined"
                                    defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.styles : [] || []}
                                    onChange={(styles) => this.handleStylesChange(styles)}
                                    allowDuplicates={false}
                                    InputProps={{
                                      inputProps: {
                                        "aria-label": "STYLES"
                                      },
                                    }}
                                  />
                                  {errors && errors.styles && (<span role="alert" className={classes.Muierror} >{errors.styles}</span>)}

                                </div>
                                <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                  <label
                                    className={classes.globalCreateLabel}
                                    htmlFor="genre"
                                  >
                                    GENRE
                                  </label>
                                  <ChipInput
                                    variant="outlined"
                                    defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.genres : [] || []}
                                    onChange={(genres) => this.handleGenresChange(genres)}
                                    allowDuplicates={false}
                                    InputProps={{
                                      inputProps: {
                                        "aria-label": "GENRES"
                                      },
                                    }}
                                  />
                                  {errors && errors.genres && (<span role="alert" className={classes.Muierror} >{errors.genres}</span>)}

                                </div>


                                <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                  <label
                                    className={classes.globalCreateLabel}
                                    htmlFor="instruments"
                                  >
                                    INSTRUMENT
                                  </label>
                                  <ChipInput
                                    variant="outlined"
                                    defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.instruments : [] || []}
                                    onChange={(instruments) => this.handleInstrumentsChange(instruments)}
                                    allowDuplicates={false}
                                    InputProps={{
                                      inputProps: {
                                        "aria-label": "INSTRUMENTS"
                                      },
                                    }}
                                  />
                                  {errors && errors.instruments && (<span role="alert" className={classes.Muierror} >{errors.instruments}</span>)}

                                </div>
                                <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                  <label
                                    className={classes.globalCreateLabel}
                                    htmlFor="keywords"
                                  >
                                    KEYWORD
                                  </label>
                                  <ChipInput
                                    variant="outlined"
                                    defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.keywords : [] || []}
                                    onChange={(keywords) => this.handleKeywordsChange(keywords)}
                                    allowDuplicates={false}
                                    InputProps={{
                                      inputProps: {
                                        "aria-label": "KEYWORDS"
                                      },
                                    }}
                                  />
                                  {errors && errors.keywords && (<span role="alert" className={classes.Muierror} >{errors.keywords}</span>)}

                                </div>
                                {/* Dont Delete this */}
                                {/* <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                  <label
                                    className={classes.globalCreateLabel}
                                    htmlFor="user_tags"
                                  >
                                    USER TAG(S)
                                  </label>
                                  <ChipInput
                                    variant="outlined"
                                    defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata.org_userTags : [] || []}
                                    onChange={(user_tags) => this.handleUserTagsChange(user_tags)}
                                    allowDuplicates={false}
                                    InputProps={{
                                      inputProps: {
                                        "aria-label": "USER TAG(S)"
                                      },
                                    }}
                                  />
                                </div> */}
                                {this.canCreateAdminNotes() && (
                                  <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="admin_tags"
                                    >
                                      TAGS
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.trackMetadata?.org_adminTags : [] || []}
                                      onChange={(admin_tags) => this.handleAdminTagsChange(admin_tags)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "ADMIN TAGS"
                                        },
                                      }}
                                    />
                                    {errors && errors.org_adminTags && (<span role="alert" className={classes.Muierror} >{errors.org_adminTags}</span>)}

                                  </div>)}


                                <div className={classes.uploadSaveButton}>

                                  <div>
                                    <Button
                                      className={classes.globalGrayButton}
                                      onClick={this.handleVisible}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      className={classes.globalGreenButton}
                                      disabled={busy ? true : false}
                                      onClick={this.handleSave}
                                    >
                                      Save
                                      {busy && (
                                        <CircularProgress size={20} className={classes.progress} />
                                      )}
                                    </Button>
                                  </div>
                                </div>

                              </div>
                            </Paper>
                          </TabPanel>
                          {!trackEditing?.albumMetadata ? null : <TabPanel
                            className={classes.trackTabs}
                            value={this.state.tabValue}
                            index={2}
                          >
                            <Paper className={classes.sidebarDataContainer} style={uploadWindow ? { height: `calc(100% - ${this.calcHeight3()}px)` } : { height: `calc(100% - ${this.calcHeightMeta()}px)` }}>
                              <div   className={clsx(classes.sidebarWrappedData, `${trackEditing ? classes.editView : ""}`, 'test3')}>
                                <div className={clsx(classes.globalInput)}>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="album_title"
                                    >
                                      Album Title<span aria-label="Album Title required" className={classes.reqSymbol}>*</span>
                                    </label>
                                    <TextInput
                                      name="album_title"
                                      type="text"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? trackEditing.albumMetadata.album_title : "" || ""}
                                      inputProps={{
                                        'aria-label': "Album Title"
                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.album_title && (<span role="alert" className={classes.appbarHideLabel} >{errors.album_title}</span>)}

                                  </div>

                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Record Label
                                    </label>
                                    <TextInput
                                      name="rec_label"
                                      type="text"
                                      classes={classes}
                                      inputProps={{
                                        'aria-label': "Rec. Label"
                                      }}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.trackMetadata ? trackEditing.trackMetadata.rec_label : "" || ""}
                                      errors={errors || {}}
                                    />
                                    {errors && errors.rec_label && (<span role="alert" className={classes.appbarHideLabel} >{errors.rec_label}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="catalogue_number"
                                    >
                                      Catalog #
                                    </label>
                                    <TextInput
                                      name="catalogue_number"
                                      type="text"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? trackEditing.albumMetadata.catalogue_number : "" || ""}
                                      inputProps={{
                                        'aria-label': "Catalogue Number"
                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.catalogue_number && (<span role="alert" className={classes.appbarHideLabel} >{errors.catalogue_number}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="album_artist"
                                    >
                                      Album Artist
                                    </label>
                                    <TextInput
                                      name="album_artist"
                                      type="text"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? trackEditing.albumMetadata.album_artist : "" || ""}
                                      inputProps={{
                                        'aria-label': "Album Artist"
                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.album_artist && (<span role="alert" className={classes.appbarHideLabel} >{errors.album_artist}</span>)}

                                  </div>

                                  {/* <div>
                                    <label
                                      className={classes.globalCreateLabel}>
                                      Prod. Year
                                    </label>
                                    <TextInput
                                      name="prod_year"
                                      type="number"
                                      classes={classes}
                                      inputProps={{
                                        'aria-label': "Prod. Year",
                                        "min": "1000",
                                        "max": "3000"
                                      }}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? trackEditing.albumMetadata.prod_year : "" || ""}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.prod_year && (<span role="alert" className={classes.appbarHideLabel} >{errors.prod_year}</span>)}

                                  </div> */}


                                  <div className={classes.calendarOverride}>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="album_release_date"
                                    >
                                      Album Release Date {" "}
                                    </label>

                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <DatePicker
                                        name="album_release_date"
                                        aria-label='Album Release Date'
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        className={clsx(classes.tableFilterInput, classes.tableFilterDate)}
                                        value={trackEditing.albumMetadata?.album_release_date ? moment(trackEditing.albumMetadata.album_release_date, 'yyyy-MM-DD').toDate() : null}
                                        onChange={event => {
                                          this.handleValChange(
                                            event ? moment(event).format('yyyy-MM-DD') : "",
                                            'album_release_date');
                                        }}
                                        autoOk
                                        inputProps={{
                                          'aria-label': 'Album Release Date'
                                        }}
                                        helperText={errors && errors["album_release_date"] || ""}
                                        error={errors && errors["album_release_date"] ? true : false}
                                      />
                                    </MuiPickersUtilsProvider>
                                  </div>

                                  <div className={classes.calendarOverride}>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="release_year"
                                    >
                                      Album Release Year {" "}
                                    </label>

                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <DatePicker
                                        name="release_year"
                                        views={["year"]}
                                        aria-label='Album Release Year'
                                        variant="inline"                                      
                                        margin="normal"
                                        className={clsx(classes.tableFilterInput, classes.tableFilterDate)}
                                        value={trackEditing.albumMetadata?.album_release_date ? moment(trackEditing.albumMetadata.release_year, 'yyyy').toDate() : null}
                                        onChange={event => {
                                          this.handleValChange(
                                            event ? moment(event).format('yyyy') : "",
                                            'release_year');
                                        }}
                                        autoOk
                                        inputProps={{
                                          'aria-label': 'Album Release Year'
                                        }}
                                        helperText={errors && errors["release_year"] || ""}
                                        error={errors && errors["release_year"] ? true : false}
                                      />
                                    </MuiPickersUtilsProvider>
                                  </div>

                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="album_discs"
                                    >
                                      NUMBER OF DISCS
                                    </label>
                                    <TextInput
                                      name="album_discs"
                                      type="number"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? parseInt(trackEditing.albumMetadata.album_discs) : "" || ""}
                                      inputProps={{
                                        'aria-label': "NUMBER OF DISCS",
                                        "min": "0",
                                        "max": "2147483647"

                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.album_discs && (<span role="alert" className={classes.appbarHideLabel} >{errors.album_discs}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="album_notes"
                                    >
                                      Album Notes
                                    </label>
                                    <TextInput
                                      name="album_notes"
                                      type="text"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? trackEditing.albumMetadata.album_notes : "" || ""}
                                      inputProps={{
                                        'aria-label': "Album Notes"
                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.album_notes && (<span role="alert" className={classes.appbarHideLabel} >{errors.album_notes}</span>)}

                                  </div>
                                  {this.canCreateAdminNotes() && (
                                    <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                      <label
                                        className={classes.globalCreateLabel}
                                        htmlFor="tags"
                                      >
                                        TAG
                                      </label>
                                      <ChipInput
                                        variant="outlined"
                                        defaultValue={trackEditing.albumMetadata ? trackEditing.albumMetadata.org_album_adminTags : [] || []}
                                        onChange={(admin_tags) => this.handleAlbumAdminTagsChange(admin_tags)}
                                        allowDuplicates={false}
                                        InputProps={{
                                          inputProps: {
                                            "aria-label": "TAGS"
                                          },
                                        }}
                                      />
                                      {errors && errors.org_album_adminTags && (<span role="alert" className={classes.Muierror} >{errors.org_album_adminTags}</span>)}

                                    </div>)}
                                  {this.canCreateAdminNotes() && (
                                    <div>
                                      <label
                                        className={classes.globalCreateLabel}>
                                        Admin Notes
                                      </label>
                                      <TextInput
                                        name="org_album_admin_notes"
                                        type="text"
                                        classes={classes}
                                        inputProps={{
                                          'aria-label': "Admin Notes"
                                        }}
                                        handleChange={this.handleValChange}
                                        value={trackEditing.albumMetadata ? trackEditing.albumMetadata.org_album_admin_notes : "" || ""}
                                        errors={errors || {}}

                                      />
                                      {errors && errors.org_album_admin_notes && (<span role="alert" className={classes.appbarHideLabel} >{errors.org_album_admin_notes}</span>)}

                                    </div>)}


                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="cLine"
                                    >
                                      CLine {" "}
                                    </label>

                                    <TextInput
                                      name="cLine"
                                      type="text"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing?.albumMetadata ? trackEditing?.albumMetadata.cLine : "" || ""}
                                      inputProps={{
                                        'aria-label': "CLine"
                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.cLine && (<span role="alert" className={classes.appbarHideLabel} >{errors.cLine}</span>)}

                                  </div>
                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="upc"
                                    >
                                      UPC
                                    </label>
                                    <TextInput
                                      name="upc"
                                      type="text"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? trackEditing.albumMetadata?.upc : "" || ""}
                                      inputProps={{
                                        'aria-label': "UPC"
                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.upc && (<span role="alert" className={classes.appbarHideLabel} >{errors.upc}</span>)}

                                  </div>

                                  <div>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="bbc_album_id"
                                    >
                                      BBC Album Barcode
                                    </label>
                                    <TextInput
                                      name="bbc_album_id"
                                      type="text"
                                      classes={classes}
                                      handleChange={this.handleValChange}
                                      value={trackEditing.albumMetadata ? trackEditing.albumMetadata?.bbc_album_id : "" || ""}
                                      inputProps={{
                                        'aria-label': " BBC Album Barcode"
                                      }}
                                      errors={errors || {}}

                                    />
                                    {errors && errors.bbc_album_id && (<span role="alert" className={classes.appbarHideLabel} >{errors.bbc_album_id}</span>)}

                                  </div>
                                  {/* <div className={clsx(classes.globalInput, classes.globaltrackEdit)}>
                                    <label
                                      className={classes.globalCreateLabel}
                                      htmlFor="album_user_tags"
                                    >
                                      USER TAG(S)
                                    </label>
                                    <ChipInput
                                      variant="outlined"
                                      defaultValue={trackEditing.trackMetadata ? trackEditing.albumMetadata.org_album_userTags : [] || []}
                                      // defaultValue={trackEditing.trackMetadata ? this.setAlbumUserTags(trackEditing.albumMetadata.album_orgTags?.userTags) : [] || []}
                                      onChange={(user_tags) => this.handleAlbumUserTagsChange(user_tags)}
                                      allowDuplicates={false}
                                      InputProps={{
                                        inputProps: {
                                          "aria-label": "USER TAG(S)"
                                        },
                                      }}
                                    />
                                  </div> */}

                                </div>
                                <div className={classes.uploadSaveButton}>

                                  <div>
                                    <Button
                                      className={classes.globalGrayButton}
                                      onClick={this.handleVisible}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      className={classes.globalGreenButton}
                                      disabled={busy ? true : false}
                                      onClick={this.handleSave}
                                    >
                                      Save
                                      {busy && (
                                        <CircularProgress size={20} className={classes.progress} />
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </Paper>
                          </TabPanel>}
                        </>
                      )
                        : (
                          <>
                            {selectedItem ? <div className={classes.noData}>
                              Nothing to preview
                            </div> : <div className={classes.noData}>
                              Nothing to preview
                            </div>}

                          </>
                        )
                      }
                    </Paper>
                  )}
                </Translation>
              </div>
            </>
            ) :
              (
                <>
                  {selectionType && selectionType === 2 ? <ContentView {...this.props} /> : selectionType === 1 ? <UploadView {...this.props} /> : null}
                </>
              )
            }
          </Paper>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  updateData: state.mlTrackUpdateReducer,
  libData: state.smContentTrackReducer,
  uploadData: state.mlUploadTracks,
  mainSearchData: state.mltracklibrary,
  uploadTrackData: state.mlSessionUploadTrackReducer,
  mainAlbumTrackData: state.mlalbumtrack,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  emptyItem,
  updateUploadTrack,
  trackEditItem,
  search,
  albumTrackSearch,
  uploadSearch,
  addSessionItems,
  mainSearch,
  showAutoMessage,
  uploadTrackSeach,
  doReloadSession,
  mainAlbumTrackSearch,
  uploadTrackSearchForPreview,
  setContributors,
  setErrors,
  contentTrackEditItem,
  setPrsTrackToEditTrack,
  showUploader
}
)(withStyles(styles)(TrackPreview));
